import "./_numbers.scss";

// Counter Animation Function
function animateCounter(element, target, suffix = '', duration = 2000) {
    const start = 0;
    const increment = target / (duration / 16); // 60fps
    let current = start;
    
    const timer = setInterval(() => {
        current += increment;
        
        if (current >= target) {
            current = target;
            clearInterval(timer);
        }
        
        // Formatta il numero con separatori di migliaia
        const formattedNumber = Math.floor(current).toLocaleString();
        element.textContent = formattedNumber + suffix;
    }, 16);
}

// Random Characters Animation (alternative effect)
function animateRandomChars(element, target, suffix = '', duration = 1500) {
    const chars = '0123456789';
    const targetStr = target.toString();
    const iterations = 20;
    let iteration = 0;
    
    const timer = setInterval(() => {
        element.textContent = targetStr
            .split('')
            .map((char, index) => {
                if (index < iteration) {
                    return char;
                }
                return chars[Math.floor(Math.random() * chars.length)];
            })
            .join('') + suffix;
        
        iteration += 1 / 3;
        
        if (iteration >= targetStr.length) {
            clearInterval(timer);
            const formattedNumber = parseInt(target).toLocaleString();
            element.textContent = formattedNumber + suffix;
        }
    }, duration / iterations);
}

// Initialize counters when elements are visible
function initializeCounters() {
    const numberElements = document.querySelectorAll('.number[data-target]');
    
    // Intersection Observer per attivare l'animazione quando visibile
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !entry.target.dataset.animated) {
                const element = entry.target;
                const target = parseInt(element.dataset.target);
                const suffix = element.dataset.suffix || '';
                
                // Trova l'indice dell'elemento per calcolare il delay
                const elementIndex = Array.from(numberElements).indexOf(element);
                const delay = elementIndex * 300; // 300ms di delay tra ogni elemento
                
                // Marca come animato per evitare ripetizioni
                element.dataset.animated = 'true';
                
                // Avvia l'animazione con delay
                setTimeout(() => {
                    // Scegli il tipo di animazione
                    animateCounter(element, target, suffix, 2500);
                    // Oppure usa l'effetto random:
                    // animateRandomChars(element, target, suffix, 1500);
                }, delay);
            }
        });
    }, {
        threshold: 0.5,
        rootMargin: '0px 0px -100px 0px'
    });
    
    numberElements.forEach(element => {
        observer.observe(element);
    });
}

// Inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', initializeCounters);